import { Pill } from '../../components/ui/index.jsx';

export const VERDICT = {
  clone: { tone: 'bad', label: 'Copy of your site' },
  brand_use: { tone: 'warn', label: 'Uses your name' },
  email_ready: { tone: 'warn', label: 'Set up to send email' },
  parked: { tone: 'neutral', label: 'Parked or for sale' },
  unreachable: { tone: 'neutral', label: 'Not answering' },
  no_site: { tone: 'neutral', label: 'No website' },
  listing_removed: { tone: 'good', label: 'Listing removed' },
  unrelated: { tone: 'neutral', label: 'Unrelated' },
  redirects_to_you: { tone: 'info', label: 'Sends people to you' },
  pending: { tone: 'neutral', label: 'Checking…' },
};
export const DECISION = {
  scam: { tone: 'bad', label: 'Scam site' },
  ours: { tone: 'good', label: 'Ours' },
  not_related: { tone: 'neutral', label: 'Not related' },
  watch: { tone: 'info', label: 'Watching' },
};
export const SOURCE = {
  variation: 'A typo or variation of your domain',
  certificate: 'A new HTTPS certificate using your name',
  email: 'Linked from a scam email',
  urlscan: 'Already scanned on urlscan.io',
  new_domain: 'In the daily list of newly registered domains',
  zone_file: 'Newly registered (ICANN zone file)',
  sighting: 'Ran your website code',
  manual: 'Added by your team',
  search: 'Found in a web search',
};

export function SiteStatus({ site }) {
  if (site.listing && site.verdict === 'no_site') return <Pill tone="good">{site.decision === 'scam' ? 'Taken down' : 'Listing removed'}</Pill>;
  if (site.decision) return <Pill tone={DECISION[site.decision].tone}>{DECISION[site.decision].label}</Pill>;
  const v = VERDICT[site.verdict] || VERDICT.pending;
  return <Pill tone={v.tone}>{v.label}</Pill>;
}

/** A domain written so it can't be clicked or mistaken for a link. */
export const defangDomain = (d) => String(d || '').replace(/\./g, '[.]');

/** "Registered 13 days ago", warning-coloured when recent. */
export function RegisteredAgo({ at, short = false }) {
  if (!at) return <span className="muted">—</span>;
  const d = new Date(String(at).includes('T') ? at : `${String(at).replace(' ', 'T')}Z`);
  if (Number.isNaN(d.getTime())) return <span className="muted">—</span>;
  const days = Math.floor((Date.now() - d.getTime()) / 86400_000);
  const text = days < 1 ? 'today' : days < 60 ? `${days} day${days === 1 ? '' : 's'} ago` : days < 730 ? `${Math.round(days / 30)} months ago` : `${Math.round(days / 365)} years ago`;
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return days < 60
    ? <Pill tone="warn">{short ? text : `Registered ${text}`}</Pill>
    : <span title={date}>{short ? text : `Registered ${text}`}<span className="muted small"> · {date}</span></span>;
}

